import { render, staticRenderFns } from "./PhotoOverlays.vue?vue&type=template&id=8a5d6f16&scoped=true"
import script from "./PhotoOverlays.vue?vue&type=script&lang=js"
export * from "./PhotoOverlays.vue?vue&type=script&lang=js"
import style0 from "./PhotoOverlays.vue?vue&type=style&index=0&id=8a5d6f16&prod&scoped=true&lang=css"
import style1 from "./PhotoOverlays.vue?vue&type=style&index=1&id=8a5d6f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5d6f16",
  null
  
)

export default component.exports